var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEtExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42 40.031V1.97C42 .883 41.117 0 40.031 0H1.97C.883 0 0 .883 0 1.969V13.78c0 .363.294.656.656.656.363 0 .656-.293.656-.656V1.97c0-.363.294-.657.657-.657H40.03c.363 0 .657.294.657.657V40.03c0 .363-.294.657-.657.657H28.22c-.363 0-.657.293-.657.656 0 .362.294.656.657.656H40.03C41.117 42 42 41.117 42 40.031z",
    transform: "translate(-159 -318) translate(33 318) translate(126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.969 17.063C.883 17.063 0 17.945 0 19.03v21C0 41.117.883 42 1.969 42h21c1.085 0 1.968-.883 1.968-1.969v-22.04l9.188-9.188v8.916c0 .362.294.656.656.656.363 0 .657-.294.657-.656v-10.5c0-.363-.294-.657-.657-.657h-10.5c-.362 0-.656.294-.656.657 0 .362.294.656.656.656h8.915l-9.188 9.188H1.968zM23.625 40.03c0 .363-.294.657-.656.657h-21c-.363 0-.657-.294-.657-.657v-21c0-.362.294-.656.657-.656h21.656v21.656z",
    transform: "translate(-159 -318) translate(33 318) translate(126)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtExpand);
export default __webpack_public_path__ + "static/media/et-expand.0b4a7c59cceb1bb804876dd58ff81738.svg";
export { ForwardRef as ReactComponent };